import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { Input, Button, Icon } from 'loyal-react'
import BoxOnboardingLink from '../Onboarding/BoxOnboardingLink'
import MediaQuery from 'react-responsive'

const toSeconds = (seconds) => {
  return [parseInt((seconds / 60) % 60), parseInt(seconds % 60)].join(':').replace(/\b(\d)\b/g, '0$1')
}

const TemporaryPassword = ({
  handleChange,
  handleBack,
  handleSendPassword,
  handleContinueTemporary,
  temporaryPassword,
  isLookingUpUsername,
  isHidden,
  email,
  getUserName,
  isEnableSend,
  timeLeft,
  error,
  ...rest
}) => {
  const handleContinueTemporaryAndFocus = (handleContinueTemporary) => {
    handleContinueTemporary()
  }

  return (
    <>
      <div id='box-temporary-password' className={`box-login box-first-access row pb-4 ${isHidden ? 'd-none' : 'accesibility-active-h1-focus'}`}>
        <div className='col-12 col-md-6 col-lg-5 mr-auto ml-auto py-3 px-3 radius bg-white border border-color-ui-3 pb-5 mb-5'>
          <div className='row'>
            <div className='col-6 col-md-12 mb-2'>
              <p className='txt-body-sm'>
                <MediaQuery maxWidth={489}>
                  <a
                    id='image-link'
                    href='#'
                    className='txt-body-sm pointer d-block'
                    aria-label='Voltar'
                    role='button'
                    onClick={handleBack}
                  >
                    <Icon className='icon icon_left_app' />
                  </a>
                </MediaQuery>
                <MediaQuery minWidth={490}>
                  <a
                    href='#'
                    className='txt-body-sm pointer d-block'
                    aria-label='Voltar'
                    role='button'
                    onClick={handleBack}
                  >
                    <Icon className='icon icon_left_app' />
                  </a>
                </MediaQuery>
              </p>
            </div>
            <MediaQuery maxWidth={489}>
              <div className='col-6 mb-2 close-login'>
                <p className='txt-body-sm'>
                  <a href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}`} className='txt-body-sm d-flex justify-content-end' aria-label='Fechar tela de login' role='button'>
                    <Icon className='icon icon_menu_app_close' />
                  </a>
                </p>
              </div>
            </MediaQuery>
          </div>
          <div className='row'>
            <div className='col-12 pt-2'>
              <h1 className='h1 login-title color-brand-1 txt-font-body mb-1'>
                {process.env.RAZZLE_MESSAGE_TEMPORARYPASSWORD_TITLE
                  ? process.env.RAZZLE_MESSAGE_TEMPORARYPASSWORD_TITLE
                  : 'Enviamos uma senha provisória para o e-mail:'}
              </h1>
              <h2 className='custon-outline login-title txt-title-3 color-brand-1 txt-font-body h3'>
                <span className='txt-bold color-brand-1'>{email}</span>
              </h2>
            </div>
            <div className='col-12 col-md-12'>
              <BoxOnboardingLink {...rest} login={getUserName} />
            </div>
            <div className='col-12 col-md-12 txt-center mt-2'>
              <Button
                className="btn btn-sm btn-featured btn-send-password"
                text={`${!isEnableSend ? 'Reenviar em 00:' + toSeconds(timeLeft) : 'Reenviar a senha provisória'}`}
                onClick={handleSendPassword}
                disabled={!isEnableSend}
                loading={isLookingUpUsername}
                type='button'
              />
              <div className='hide-absolute' aria-live='assertive' role='status' aria-atomic='true'>
                {!isHidden && !isEnableSend && 'Por favor, confira a senha temporaria em seu e-mail'}
              </div>
            </div>
            <div className='hr mt-2' />
            <div className='col-12 pt-2'>
              <p className='txt-body-sm mb-1'>após receber a senha provisória continue</p>
            </div>
            <div className='col-12 col-md-12 txt-center mt-2'>
              <Button
                className='btn btn-sm btn-secondary btn-continue'
                text='Continuar'
                type='button'
                onClick={() => handleContinueTemporaryAndFocus(handleContinueTemporary)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

TemporaryPassword.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleContinueTemporary: PropTypes.func.isRequired,
  temporaryPassword: PropTypes.string,
  isHidden: PropTypes.bool,
  email: PropTypes.string,
  getUserName: PropTypes.func.isRequired,
  error: PropTypes.object
}

export default withRouter(TemporaryPassword)
